

class EventTabs {

	constructor(node, config = {}) {
		this.index = -1;
		this.node = node;

		this.config = Object.assign({
			contentsActiveClass		: 'interactive-tabs__tab--active',
			contentsClass      		: 'interactive-tabs__tab',
			interactiveClass   		: 'interactive-tabs--interactive',
			navClass           		: 'interactive-tabs__nav',
			navActiveClass     		: 'interactive-tabs__nav--active',
			navItemClass       		: 'interactive-tabs__nav-item',
			navItemActiveClass 		: 'interactive-tabs__nav-item--active',
			indexNavItemClass 		: 'interactive-tabs__index',
			indexNavItemActiveClass : 'interactive-tabs__index--active',
			navLinkClass       		: 'interactive-tabs__nav-link',
			currentItemClass   		: 'interactive-tabs__nav-current',
		}, config);

		if (!this.node || this.node.classList.contains(this.config.interactiveClass)) {
			return;
		}

		this.hashMap = {};

		this.nav = this.node.querySelector(`.${this.config.navClass}`);
		const navIndexs = Array.from(this.node.querySelectorAll(`.${this.config.indexNavItemClass}`));
		const navItems = Array.from(this.node.querySelectorAll(`.${this.config.navItemClass}`));
		const navLinks = Array.from(this.node.querySelectorAll(`.${this.config.navLinkClass}`));

		this.currentItem = this.node.querySelector(`.${this.config.currentItemClass}`);

		if ( this.currentItem && this.nav ) {
			this.currentItemText = this.currentItem.querySelector('span');

			this.currentItem.addEventListener( 'click', () => {
				this.nav.classList.toggle( this.config.navActiveClass );
			} );
		}

		this.tabs = Array.from(this.node.querySelectorAll(`.${this.config.contentsClass}`)).map((content, index) => {
			const link = navLinks[index];
			const navIndex = navIndexs[index];
			const navItem = navItems[index];
			const hash = link.getAttribute('href').replace(/^#/, '');

			content.setAttribute('role', 'tabpanel');
			content.setAttribute('tabindex', -1);

			this.hashMap[hash] = index;

			return {
				opened: false,
				content,
                hash,
				link,
				navItem,
				navIndex
			}
		});

		this.nav.addEventListener('click', (e) => {
			let target = e.target;

			while (target && target !== this.nav) {
				if (target.classList.contains(this.config.navLinkClass) && target.hash) {
					e.preventDefault();
					this.nav.classList.remove( this.config.navActiveClass );
					this.goToHash(target.hash);
					break;
				}

				target = target.parentNode;
			}
		});

		if (window.location.hash) {
			this.goToHash(window.location.hash, false);
		}

		window.addEventListener('hashchange', () => this.goToHash(window.location.hash));
		window.addEventListener('popstate', () => this.goToHash(window.location.hash));

		if (this.index === -1) {
			this.goTo(0, false);
		}

		this.node.classList.add(this.config.interactiveClass);
	}

	goToHash(hash, history = true) {
		hash = hash.replace(/^#/, '');

		if (this.hashMap[hash] > -1) {
			this.goTo(this.hashMap[hash], history);
		}
	}

	goTo(index, history = true) {
		if (this.index > -1) {
			if (this.tabs[this.index].navItem) {
				this.tabs[this.index].navItem.classList.remove(this.config.navItemActiveClass);
				this.tabs[this.index].navIndex.classList.remove(this.config.indexNavItemActiveClass);
			}

			this.tabs[this.index].content.classList.remove(this.config.contentsActiveClass);
			this.tabs[this.index].content.setAttribute('tabindex', '-1');
			this.tabs[this.index].content.removeAttribute('aria-selected');
		}

		this.index = index;

		if (!this.tabs[this.index]) {
			return;
		}

		if (this.tabs[this.index].navItem) {
			this.tabs[this.index].navItem.classList.add(this.config.navItemActiveClass);
			this.tabs[this.index].navIndex.classList.add(this.config.indexNavItemActiveClass);
		}

		this.tabs[this.index].content.classList.add(this.config.contentsActiveClass);
		this.tabs[this.index].content.setAttribute('aria-selected', 'true');
		this.tabs[this.index].content.removeAttribute('tabindex', '-1');
		this.tabs[this.index].content.focus();

		if ( history && window.location.hash !== `#${this.tabs[this.index].hash}`) {
			window.history.replaceState( '', '', `#${this.tabs[this.index].hash}` );
		}

		if ( this.currentItemText ) {
			this.currentItemText.innerText = this.tabs[this.index].link.innerText.trim();
		}

		window.dispatchEvent(new CustomEvent('resize'));
	}

	open(index, history) {
		this.tabs[index].opened = true;
		this.tabs[index].content.classList.add(this.config.contentsOpenClass);
		this.goTo(index, history);
	}

	close(index) {
		this.tabs[index].opened = false;
		this.tabs[index].content.classList.remove(this.config.contentsOpenClass);
	}

	toggle(index) {
		return this.tabs[index].opened ? this.close(index) : this.open(index);
	}

}

EventTabs.instances = Array.from(document.querySelectorAll('.interactive-tabs')).map(n => new EventTabs(n));

export default EventTabs;
